import type { LicenseStatus } from '@/features/Licenses/api/licenseHooks'
import { Badge, type BadgeProps } from '@chakra-ui/react'

function statusColor(status: LicenseStatus): string {
  if (status === 'ACTIVE') {
    return 'green'
  }
  if (status === 'EXPIRED') {
    return 'gray'
  }
  return 'red'
}

type Props = {
  status: LicenseStatus
} & Omit<BadgeProps, 'colorPalette' | 'children'>

/**
 * The licence status pill. Single source of the status → colour mapping, which
 * was previously copy-pasted between the licences table and the detail page —
 * and is now needed in a third place (the detail page title), so the two
 * copies became one.
 *
 * Presentation props pass through, so the table keeps the small default while
 * the detail page title can size it up.
 */
export function LicenseStatusBadge({ status, ...badge }: Readonly<Props>) {
  return (
    <Badge variant="subtle" {...badge} colorPalette={statusColor(status)}>
      {status}
    </Badge>
  )
}
